import styled from 'styled-components';

// eslint-disable-next-line
export const FavBtn = styled.button.attrs({
  type: 'button',
  className: 'btn-favorite'
})`
  font-size: 0;

  .svg-star {
    width: 20px;
    height: 20px;
    stroke: ${({ theme }) => theme.color.textPrimary};
    stroke-width: 2px;
    fill: transparent;
    transition: fill 0.2s ease-out, stroke 0.2s ease-out;
  }

  &:hover {
    .svg-star {
      stroke: ${({ theme }) => theme.color.accent};
    }
  }

  &._selected {
    .svg-star {
      fill: ${({ theme }) => theme.color.accent};
      stroke: ${({ theme }) => theme.color.accent};
    }
  }

  &._pending {
    pointer-events: none;
    backface-visibility: hidden;

    .svg-star {
      opacity: 0.7;
      animation: rotate 0.3s ease-out infinite alternate;
    }
  }

  ${({ withBookmark }) =>
    withBookmark &&
    `
    position: absolute;
    left: 0;
    top: 0;
    
    .svg-bookmark {
      width: 40px;
      height: 50px;
    }
    
    .svg-star {
      width: 24px;
      height: 24px;

      position: absolute;
      left: 50%;
      top: 50%;
      
      margin: -15px 0 0 -12px;
    }
  `}
`;
